import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomerViewComponent } from './customer_view.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [CustomerViewComponent],
  exports: [
    CustomerViewComponent
  ],
  providers: [
  ]
})
export class CustomerViewModule { }
